import React from 'react'
import BreadCrumb from '../components/BreadCrumb'
import Header from '../components/header'
import Footer from '../components/footer'

function PrivacyPage() {
  const pageName = "Privacy Policy"
  return (
    <div className='home-3'>
      <Header/>
      <BreadCrumb pageName={pageName}/>
      <main>
        <div class="pt-120 pb-120">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="terms-content">
                            <h1>Privacy Policy – TaxiDo</h1>
    
                            <h4>INTRODUCTION</h4>
                            <ul>
                                <li>This document sets out the privacy policy of TaxiDo.</li>
                                <li>We take our privacy obligations seriously and we’ve created this privacy policy to explain how we store, maintain, use and disclose personal information.</li>
                                <li>By providing personal information to us, you consent to our storage, maintenance, use and disclosure of personal information in accordance with this privacy policy.</li>
                                <li>We may change this privacy policy from time to time by posting an updated copy on our website and we encourage you to check our website regularly to ensure that you are aware of our most current privacy policy.</li>
                            </ul>
                        </div>

                        <div class="terms-content">
                            <h4>TYPES OF PERSONAL INFORMATION WE COLLECT</h4>
                            <ul>
                                <li>Name</li>
                                <li>User's image for profile image from the camera or storage</li>
                                <li>Mailing or street address</li>
                                <li>Email address</li>
                                <li>Social media information</li>
                                <li>Telephone number and other contact details</li>
                                <li>Age</li>
                                <li>Date of birth</li>
                                <li>Credit card or other payment information</li>
                                <li>Sensitive information as set out below (including criminal records)</li>
                                <li>Geo-location information</li>
                                <li>Identity documents such as your driver’s license</li>
                                <li>Information about your business or personal circumstances</li>
                                <li>Information in connection with client surveys, questionnaires, and promotions</li>
                                <li>Your device identity and type, I.P. address, geo-location information, page view statistics, advertising data, and standard web log information</li>
                                <li>Information about third parties</li>
                                <li>Any other information provided by you to us via our website or our online presence or otherwise required by us or provided by you.</li>
                            </ul>
                        </div>

                        <div class="terms-content">
                            <h4>HOW WE COLLECT PERSONAL INFORMATION</h4>
                            <ul>
                                <li>We may collect personal information either directly from you or from third parties, including where you:</li>
                                <ul>
                                    <li>Contact us through our website <a href="https://www.serviswiftmw.com/">https://www.serviswiftmw.com/</a></li>
                                    <li>Use our services or otherwise receive services from us</li>
                                    <li>Download our application</li>
                                    <li>Submit any of our online sign-up forms</li>
                                    <li>Communicate with us via email, telephone, SMS, social applications (such as LinkedIn, Facebook, or Twitter) or otherwise</li>
                                    <li>Interact with our website, social applications, services, content, and advertising</li>
                                    <li>Invest in our business or inquire about a potential purchase in our business.</li>
                                </ul>
                            </ul>
                        </div>

                        <div class="terms-content">
                            <h4>USE OF YOUR PERSONAL INFORMATION</h4>
                            <ul>
                                <li>We collect and use personal information for the following purposes:</li>
                                <ul>
                                    <li>To provide goods, services, or information to you</li>
                                    <li>To store your identity documents for verification purposes</li>
                                    <li>For safety purposes and in case of an emergency</li>
                                    <li>For record-keeping and administrative purposes</li>
                                    <li>To provide information about you to our contractors, employees, consultants, agents, or other third parties for the purpose of providing goods or services to you</li>
                                    <li>To improve and optimize our service offering and customer experience</li>
                                    <li>To comply with our legal obligations, resolve disputes, or enforce our agreements with third parties</li>
                                    <li>To send you marketing and promotional messages and other information that may be of interest to you and for the purpose of direct marketing (in accordance with the Spam Act). In this regard, we may use email, SMS, social media, or mail to send you direct marketing communications. You can opt-out of receiving marketing materials from us by using the opt-out facility provided (e.g. an unsubscribe link)</li>
                                    <li>To send you administrative messages, reminders, notices, updates, security alerts, and other information requested by you</li>
                                    <li>To consider an application of employment from you.</li>
                                    <li>We may disclose your personal information to cloud providers, contractors, and other third parties located inside or outside of Australia. If we do so, we will take reasonable steps to ensure that any overseas recipient deals with such personal information in a manner consistent with how we deal with it.</li>
                                </ul>
                            </ul>
                        </div>

                        <div class="terms-content">
                            <h4>USER'S IMAGE</h4>
                            <ul>
                                <li>We collect and use images you provide for the following purposes:</li>
                                <ul>
                                    <li><b>Profile Picture:</b> We collect and display the profile picture you upload within the App for user identification and enhanced user experience.</li>
                                    <li><b>Document Verification:</b> In certain cases, we may require you to submit images of documents for verification purposes. We use these images solely for verifying your identity or fulfilling legal/regulatory requirements.
                                    We take reasonable measures to protect your images from unauthorized access, alteration, or destruction.
                                    The App is not intended for individuals under 18. We do not knowingly collect information from children under 18.
                                    </li>
                                </ul>
                            </ul>
                        </div>

                        <div class="terms-content">
                            <h4>DATA SECURITY</h4>
                            <p>We take appropriate measures to protect your contacts’ information from unauthorized access, alteration, disclosure, or destruction. We implement industry-standard security practices and regularly update our systems to safeguard your data.</p>
                        </div>

                        <div class="terms-content">
                            <h4>SENSITIVE INFORMATION</h4>
                            <p>We may collect sensitive information about you during the course of providing you services. The type of sensitive information we may collect includes your criminal records.</p>
                            <p>We will only collect this sensitive information where you consent and provide us with this information. If you consent, your sensitive information may only be used and disclosed for purposes relating to providing you with our services.</p>
                            <p>Your sensitive information may also be used or disclosed to comply with our legal obligations.</p>
                        </div>

                        <div class="terms-content">
                            <h4>SECURITY</h4>
                            <p>We take reasonable steps to ensure your personal information is secure and protected from misuse or unauthorized access. Our information technology systems are password-protected, and we use a range of administrative and technical measures to protect these systems. However, we cannot guarantee the security of your personal information.</p>
                        </div>

                        <div class="terms-content">
                            <h4>LINKS</h4>
                            <p>Our website may contain links to other websites. Those links are provided for convenience and may not remain current or be maintained. We are not responsible for the privacy practices of those linked websites, and we suggest you review the privacy policies of those websites before using them.</p>
                        </div>

                        <div class="terms-content">
                            <h4>REQUESTING ACCESS OR CORRECTING YOUR PERSONAL INFORMATION</h4>
                            <p>If you wish to request access to the personal information we hold about you, please contact us using the contact details set out below, including your name and contact details. We may need to verify your identity before providing you with your personal information. In some cases, we may be unable to provide you with access to all your personal information, and where this occurs, we will explain why. We will deal with all requests for access to personal information within a reasonable time-frame.</p>
                            <p>If you think that any personal information we hold about you is inaccurate, please contact us using the contact details set out below, and we will take reasonable steps to ensure that it is corrected.</p>
                            <p></p>
                        </div>

                        <div class="terms-content">
                            <h4>COMPLAINTS</h4>
                            <p>If you wish to complain about how we handle your personal information held by us, please contact us using the details set out below, including your name and contact details. We will investigate your complaint promptly and respond to you within a reasonable time-frame.</p>
                        </div>

                        <div class="terms-content">
                            <h4>CONTACT US</h4>
                            <p>For further information about our privacy policy or practices, or to access or correct your personal information, or make a complaint, please contact us using the details set out below:
                            </p>
                            <p>- Email: <a href="mailto:support@serviswiftmw.com">support@serviswiftmw.com</a></p>
                        </div>

                    </div>
                </div>
            </div>
        </div>

      </main>
      <Footer/>
    </div>
  )
}

export default PrivacyPage